<i [class]="currentClass"></i>

